import './styles.scss';

import React, {CSSProperties, PropsWithChildren} from 'react';

interface AppKeyTextProps extends PropsWithChildren {
    style?: CSSProperties;
}

export const AppKeyText = ({style, children}: AppKeyTextProps) => {
    return (
        <h3 className='app-key-text' style={style}>
            {children}
        </h3>
    );
};
